import RelayRootContainer from './RelayRootContainer';
export default RelayRootContainer;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/index.js